<template>
 <a :href="btnSrc" target="_blank">  
    <button class="button">
        <slot>Button</slot> 
    </button>
</a>    
</template>

<script>
export default {
  props: {
    btnSrc: {
      type: String,
      required: true
    },
  },  
  components: {

  },
}
</script>

<style>

.button {
  width: 12rem;
  height: 3rem;
  font-size: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
}

a {
  text-decoration: none;
  align-self: center;
}


</style>